import type { CSSProperties, FC, PropsWithChildren, ReactNode } from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { Trans } from 'react-i18next';

import { MuiButton } from '@shared/ui-kit';

import { StubContainer, StubDescription, StubIconWrapper, StubTitle, StubWrapper } from './Stub.style';

import type { MuiButtonProps } from '@shared/ui-kit';

export type StubConfigProps = {
  title?: string;
  description?: string;
  subDescription?: string;
  img?: string;
  subtitle?: string;
  imageAlt?: string;
};

type Props = {
  config: StubConfigProps;
  buttonProps?: MuiButtonProps;
  renderButtonComponent?: () => ReactNode;
  alignItems?: CSSProperties['alignItems'];
};

// TODO - remove subDescription and subtitle when they decide what to do where they stayed
export const Stub: FC<PropsWithChildren<Props>> = ({
  config,
  buttonProps,
  alignItems,
  renderButtonComponent,
  children,
}) => {
  const theme = useTheme();
  return (
    <StubContainer alignItems={alignItems}>
      <StubWrapper>
        {config.title && <StubTitle variant="s1">{config.title}</StubTitle>}

        {config.description && (
          <StubDescription variant="t14r">
            <Trans
              defaults={config.description}
              components={{
                greenText: <Box component="span" sx={{ color: theme.palette.case.aquamarine.a700 }} />,
              }}
            />
          </StubDescription>
        )}

        {config.img && (
          <StubIconWrapper>
            <img src={config.img} alt={config.imageAlt} width="100%" />
          </StubIconWrapper>
        )}

        {(config.subtitle || config.subDescription) && (
          <Typography
            sx={{
              width: '100%',
              margin: '20px 0 16px 0',
              color: theme.palette.case.neutral.n700,
            }}
            variant="h3"
          >
            {config.subtitle ? config.subtitle || '' : config.subDescription || ''}
          </Typography>
        )}

        {buttonProps && (
          <Box mt="24px">
            <MuiButton size="small" {...buttonProps} />
          </Box>
        )}
        {renderButtonComponent && <Box sx={{ mt: '16px' }}>{renderButtonComponent()}</Box>}
        {children}
      </StubWrapper>
    </StubContainer>
  );
};
